/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { v1FehlerlistePost } from '../fn/fehlerliste-ignorieren/v-1-fehlerliste-post';
import { V1FehlerlistePost$Params } from '../fn/fehlerliste-ignorieren/v-1-fehlerliste-post';

@Injectable({ providedIn: 'root' })
export class FehlerlisteIgnorierenApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `v1FehlerlistePost()` */
  static readonly V1FehlerlistePostPath = '/v1/fehlerliste';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `v1FehlerlistePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1FehlerlistePost$Response(params?: V1FehlerlistePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return v1FehlerlistePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `v1FehlerlistePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  v1FehlerlistePost(params?: V1FehlerlistePost$Params, context?: HttpContext): Observable<void> {
    return this.v1FehlerlistePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
